import { DOCUMENT } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	inject,
	OnInit,
	Renderer2,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ClientScreen, ClientService } from '~app-client/core/services';

@Component({
	selector: 'screen-reactor',
	template: ``,
	styles: [':host { display: none; } '],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [],
})
export class ScreenReactorComponent implements OnInit {
	private static screenToClass(screen: ClientScreen): string {
		return `screen-${screen}`.toLowerCase();
	}

	private readonly destroyRef = inject(DestroyRef);
	private readonly screen$ = inject(ClientService).screen$;
	private readonly renderer = inject(Renderer2);
	private readonly hostElement = inject(DOCUMENT).documentElement;

	ngOnInit(): void {
		this.screen$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((screen) => {
			this.removeAllClasses();
			this.addClass(screen);
		});
	}

	private removeAllClasses(): void {
		Object.values(ClientScreen).map((screen) => {
			this.renderer.removeClass(
				this.hostElement,
				ScreenReactorComponent.screenToClass(screen)
			);
		});
	}

	private addClass(screen: ClientScreen): void {
		this.renderer.addClass(this.hostElement, ScreenReactorComponent.screenToClass(screen));
	}
}
